export const sortIncidents = (incidents) =>
  [...incidents].sort(
    (a, b) =>
      Number(b.status === "unacknowledged") -
        Number(a.status === "unacknowledged") ||
      Number(a.is_test === true) - Number(b.is_test === true) ||
      new Date(a.detected_at).getTime() - new Date(b.detected_at).getTime()
  );
export const socketUrl = () => "wss://www.monger.tech/api/ws";
export const describeError = (error) =>
  error?.response?.data?.message ||
  error?.message ||
  "Unable to contact the duress service";
export const elapsed = (time, now = Date.now()) => {
  if (!time) return "Unknown";
  const seconds = Math.max(
    0,
    Math.floor((now - new Date(time).getTime()) / 1000)
  );
  if (!Number.isFinite(seconds)) return "Unknown";
  if (seconds < 60) return `${seconds}s`;
  if (seconds < 3600) return `${Math.floor(seconds / 60)}m`;
  return `${Math.floor(seconds / 3600)}h ${Math.floor((seconds % 3600) / 60)}m`;
};
export const handlingTime = (startedAt, endedAt = Date.now()) => {
  if (!startedAt) return "--:--";
  const seconds = Math.max(
    0,
    Math.floor(
      (new Date(endedAt).getTime() - new Date(startedAt).getTime()) / 1000
    )
  );
  if (!Number.isFinite(seconds)) return "--:--";
  const parts = [Math.floor((seconds % 3600) / 60), seconds % 60];
  if (seconds >= 3600) parts.unshift(Math.floor(seconds / 3600));
  return parts.map((part) => String(part).padStart(2, "0")).join(":");
};
export const CLAIM_BANNER_MS = 60000;
export const claimTime = (incident) => {
  const claimed =
    incident.claimed_at && new Date(incident.claimed_at).getTime();
  if (Number.isFinite(claimed)) return claimed;
  // Older incident details may have the claim only in their event history.
  const claims = (incident.events || [])
    .filter((event) => ["claimed", "taken_over"].includes(event.type))
    .map((event) => new Date(event.occurred_at).getTime())
    .filter(Number.isFinite);
  return claims.length ? Math.max(...claims) : null;
};
export const showIncidentBanner = (incident, now = Date.now()) => {
  if (incident.status === "unacknowledged") return true;
  if (incident.status !== "acknowledged") return false;
  const claimed = claimTime(incident);
  return claimed !== null && now < claimed + CLAIM_BANNER_MS;
};
export const position = (location) =>
  location
    ? `${Number(location.lat).toFixed(5)}, ${Number(location.lon).toFixed(5)}`
    : "Location unavailable";
